import {
    TemperatureRange,
    LaneStatus,
    LeaseType,
    CollectionServiceType,
    DeliveryServiceType,
} from 'app/enums/label.enums'
import {
    DTOCardFormField,
} from 'app/types/form.types'

import {
    AccountLane,
} from 'app/Apps/AccountManagement/AccountLanes/AccountLanes.types'

const getFields = (
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
): DTOCardFormField<keyof AccountLane>[] => {
    return [
        {
            id: 'generalInformation',
            title: 'General Information',
            className: 'generalInformation',
            fields: [
                {
                    id: 'column1',
                    fields: [
                        {
                            name: 'laneNumber',
                            componentName: 'InputSingleline',
                            labelKey: 'LaneOpsInformationDto.laneNumber',
                        },
                        {
                            name: 'leaseType',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(LeaseType),
                            labelKey: 'LaneOpsInformationDto.leaseType',
                        },
                        {
                            name: 'createdBy',
                            componentName: 'InputSingleline',
                            labelKey: 'LaneOpsInformationDto.createdBy',
                        },
                        {
                            name: 'deliveryServiceType',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(DeliveryServiceType),
                            labelKey: 'LaneOpsInformationDto.deliveryServiceType',
                        },
                    ],
                },
                {
                    id: 'column2',
                    fields: [
                        {
                            name: 'laneStatus',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(LaneStatus),
                            labelKey: 'LaneOpsInformationDto.laneStatus',
                        },
                        {
                            name: 'temperatureRange',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(TemperatureRange),
                            labelKey: 'LaneOpsInformationDto.tempRange',
                        },
                        {
                            name: 'collectionServiceType',
                            componentName: 'EnumSelector',
                            allowedValues: getAllowedValues(CollectionServiceType),
                            labelKey: 'LaneOpsInformationDto.collectionServiceType',
                        },
                    ],
                },
            ],
        },
        {
            id: 'customer',
            title: 'Customer',
            className: 'customer',
            fields: [{
                name: 'customerExecution',
                componentName: 'LocationObjectSelector',
                labelKey: 'LaneOpsInformationDto.customerExecution',
            }],
        },
        {
            id: 'airports',
            title: 'Airports',
            className: 'airports',
            fields: [
                {
                    name: 'originAirport',
                    componentName: 'LocationObjectSelector',
                    labelKey: 'LaneOpsInformationDto.originAirport',
                },
                {
                    name: 'destinationAirport',
                    componentName: 'LocationObjectSelector',
                    labelKey: 'LaneOpsInformationDto.destAirport',
                },
            ],
        },

    ]
}

export default getFields
